<script lang="ts" setup>
import { ButtonStyle } from '~/static/enums/components/button'
import AButton from '~/components/atoms/buttons/Button.vue'
import RModal from '~/components/organs/Modal.vue'

const openSupport = () => {
  window.open('https://t.me/magvi_bot', '_blank')
}

const refModal: Ref = ref(null)
const closeModal = () => {
  if (refModal.value !== null) {
    refModal.value.closeModal()
  }
}
const openModal = () => {
  if (refModal.value !== null) {
    refModal.value.openModal()
  }
}
defineExpose({
  closeModal,
  openModal,
})

</script>

<template>
  <RModal
    name-modal="SubscriptionByReview"
    ref="refModal"
    :width="671"
    :max-width="671"
  >
    <template #header>
      <h5
        class="modal-title fs-5"
        id="SubscriptionByReview"
      >
        Оплата для юрлиц
      </h5>
    </template>
    <template #body>
      Оплата доступна только для <b>годовых тарифов</b>. Чтобы получить счёт-оферту,
      направьте в поддержку в Телеграм или на эл. почту info@magvi.ru:
      <ol type="a">
        <li>название тарифа («Старт», «Про» или «Макс»),</li>
        <li>реквизиты ИП или ООО: наименование, ИНН, ОГРН/ОГРНИП, юридический адрес, адрес электронной почты,</li>
      </ol>
      Наш специалист подготовит и направит счёт-оферту в течение 2 рабочих дней.
    </template>
    <template #footer>
      <AButton
        :button-style="ButtonStyle.Primary"
        @click="openSupport"
      >
        Написать в поддержку
      </AButton>
    </template>
  </RModal>
</template>

<style lang="scss" scoped>
.body {
  width: 498px;
}
</style>
